(function($){
/*START CUSTOM JS*/
  
//   removal
 window.globalThis._0x9401=0;
// window.globalThis.theme.isThemeDemo = false;
 window['theme'].host = "shella";

//review  tab scroll
$( "#review" ).click(function(e) {
  e.preventDefault(), e.stopImmediatePropagation();
  if($(window).width() > 1024) {
    $("[data-tab^='description']").click();
    $("[data-tab^='reviews']").click();
    $('html, body').animate({
      scrollTop: $('#tab-reviews').offset().top - 0
    }, 1500);
  }
  else {
    $("[data-tab^='mobile-description']").click();
    $("[data-tab^='mobile-reviews']").click();
    $('html, body').animate({
      scrollTop: $('#mobile-tab-reviews').offset().top - $("#mobile-tab-description").height() - 50
    }, 1500);
  }
  
});

//review mobile tab scroll
$( "#mobile-review" ).click(function(e) {
  e.preventDefault(), e.stopImmediatePropagation();
  $("[data-tab^='mobile-description']").click();
  $("[data-tab^='mobile-reviews']").click();
  $('html, body').animate({
    scrollTop: $('#mobile-tab-reviews').offset().top - $("#mobile-tab-description").height() - 50
  }, 1500);
});  
  
/*END CUSTOM JS*/  
})(jQueryTheme);